import { Grid, Tabs } from "@mui/material"
import { styled } from "@mui/material/styles"
import { sharedStyle } from "../sharedTabsStyle"

export const tabsStyle = ({ theme }) => ({
  ".MuiTabs-root": {
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center"
    }
  },
  ".MuiTabs-scroller": {
    [theme.breakpoints.down("md")]: {
      flexGrow: "0"
    }
  },
  ".MuiTabs-indicator": {
    height: 4
  }
})

const StyledTabsBase = styled(Tabs)(sharedStyle)
export const StyledTabs = styled(StyledTabsBase)(tabsStyle) // TODO: responsive style not applying
export const StyledGrid = styled(Grid)(sharedStyle)
